export default __webpack_public_path__ + "static/media/logo_nosub.2551724d.svg";